enum TKDefaultGeocoderNames {
    geolocation = "geolocation",
    recent = "recent",
    favourites = "favourites",
    skedgo = "skedgo",
    cities = "cities"
}

export default TKDefaultGeocoderNames;